import * as Images from './Images';
import {LARGE, MEDIUM, SMALL, SMALL_COLOR} from './IconSize';
import React from 'react';
export const CDN_URL = '//csvcus.homeaway.com/rsrcs-crs/traveler/react-urgency-messaging';

const LINK_PLACEHOLDER = '{LINK_PLACEHOLDER}';

export const EdapEventFields = {
    EVENT: 'generic.event',
    CATEGORY: 'Urgency Messages',
    DESTINATION_MESSAGE_LABEL: 'DestinationMessage',
    UNIT_MESSAGE_LABEL: 'UnitMessage'
};

export const types = {
    [SMALL]: 'grayscale',
    [MEDIUM]: 'color',
    [LARGE]: 'animation',
    [SMALL_COLOR]: 'color_small'
};

export const sizes = {
    [SMALL]: '16px',
    [MEDIUM]: '24px',
    [LARGE]: '32px'
};

export const buildImageUrl = (type) => `${CDN_URL}/${Images[type]}`;

export const buildType = (iconType, iconSize, color) => {
    const size = iconSize === SMALL && color ? SMALL_COLOR : iconSize;
    return `${iconType}_${types[size]}`.toUpperCase();
};

export const getIconProps = (iconType, iconSize, color) => ({
    style: {
        width: sizes[iconSize],
        height: sizes[iconSize]
    },
    src: iconType ? buildImageUrl(buildType(iconType, iconSize, color)) : null
});

export const buildMessage = (message, link, linkClass) => {
    if (!link || !link.linkText || !link.linkHref || !message.includes(LINK_PLACEHOLDER)) {
        return message;
    }
    const anchor = <a className={linkClass} href={link.linkHref} target="_blank">{link.linkText}</a>;
    const placeholderIndex = message.indexOf(LINK_PLACEHOLDER);
    const bodyText = message.substring(0, placeholderIndex);
    const tail = message.substring(placeholderIndex + LINK_PLACEHOLDER.length);

    return [bodyText, anchor, tail];
};
